Ctrl.$inject = ['$scope', '$state', 'PortalApi', '$stateParams', 'Analytics', '$rootScope', 'Localization'];

function Ctrl($scope, $state, PortalApi, $stateParams, Analytics, $rootScope, Localization) {
    $scope.recoveryStep = '';
    $scope.recPassForm = {};
    $scope.preLoader = false;
    $scope.smsSender = {};
    $scope.recoveryPassAttempt = 0;

    $scope.init = function () {

        $scope.recPassForm = {
            login: '',
            password: '',
            password_repeat: '',
            captcha:''
        };

        $scope.recoveryStep = 'login';
        $scope.fromUser = $stateParams;
    };

    if($rootScope.useFrame && $state.current.data.iframe == false){
        document.body.classList.remove('bodyContainer');
        $state.go('pages.error404');
        $rootScope.useFrame = false;
    }

    $scope.activeSliderFormPreLoader = function (active) {
        $scope.preLoader = active || false;
    };

    $scope.sendCode = function () {
        $scope.activeSliderFormPreLoader(true);

        PortalApi.sendRecoveryPassCode($scope.recPassForm).then(
            function (response) {

                if (response.status !== 'ok') {
                    return Localization.notifyTemplate('error', 'NOTIFICATION.LOGIN_RECOVER.NOT_FOUND', 5, true);
                }
                $scope.recoveryPassAttempt++;

                Analytics.trackEvent(
                    'Восстановление пароля',
                    'Успешно',
                    'Подтверждение кода' + $scope.recoveryPassAttempt + 'попытка'
                );
                Analytics.pageView();

                Localization.notifyTemplate('info', 'NOTIFICATION.LOGIN_RECOVER.SEND', 5, true);

                $scope.recoveryStep = 'passwordChange';
            },
            function () {
                $scope.recoveryPassAttempt++;

                Analytics.trackEvent(
                    'Востановление пароля',
                    'Не успешно',
                    'Подтверждение кода' +  $scope.recoveryPassAttempt +'попытка'
                );
                Analytics.pageView();

                Localization.notifyTemplate('error', 'NOTIFICATION.LOGIN_RECOVER.SEND_ERROR', 5, true);
            }
        ).finally(function () {
            $scope.activeSliderFormPreLoader();
        });
    };

    $scope.changePassword = function () {
        $scope.activeSliderFormPreLoader(true);

        PortalApi.changePassword($scope.recPassForm).then(
            function (response) {

                if (response.status !== 'ok') {
                   return Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.WRONG_CODE', 5, true);
                }

                Localization.notifyTemplate('success', 'NOTIFICATION.SUCCESS.PASSWORD_SUCCESS_WILLBE', 5, true);

                $state.go('pages.main');
            },
            function () {
                Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.OOPS_ERROR', 5, true);
            }
        ).finally(function () {
            $scope.activeSliderFormPreLoader();
        });
    };

    $scope.init();
}

module.exports = Ctrl;



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/passwordRecovery/controllers/passwordRecovery.controller.js
 ** module id = 279
 ** module chunks = 1
 **/